import { Injectable, InjectionToken } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export enum States {
  Tenants = 'tenants',
  TenantSummary = 'tenant-summary',
}

export interface StateData {
  tenantIds: number[];
}

export interface FloorSpaceDetailsHandlerSrv {
  stateData$: Observable<StateData>;
  state$: Observable<States>;
  getState(): States;
  resetState(): void;
  nextState(stateData: StateData): void;
}

export const FLOOR_SPACE_DETAILS_STATE_HANDLER_TOKEN = new InjectionToken<FloorSpaceDetailsHandlerSrv>(
  'FloorSpaceDetailsHandlerSrv'
);

@Injectable()
export class FloorSpaceDetailsStateHandlerService implements FloorSpaceDetailsHandlerSrv {
  #state = new BehaviorSubject<States>(States.Tenants);
  state$ = this.#state.asObservable();

  #stateData = new BehaviorSubject<StateData>(null);
  stateData$ = this.#stateData.asObservable();

  nextState(stateData?: StateData) {
    this.#stateData.next(stateData);
    const currentState = this.getState();
    switch (currentState) {
      case States.Tenants:
        this.#state.next(States.TenantSummary);
        break;
      case States.TenantSummary:
        this.#state.next(States.Tenants);
        break;
    }
  }

  getState(): States {
    return this.#state.getValue();
  }

  resetState() {
    this.#state.next(States.Tenants);
    this.#stateData.next(null);
  }
}
